<template>
    <v-app>
        <AppWrapperView>
            <v-main>
                <v-container class="pa-8" fluid>

                    <v-form @submit.prevent="search" ref="formRefs">
                        <v-row>
                            <v-col cols="3">
                                <v-autocomplete density="compact" variant="outlined" hide-details="auto"
                                    v-model="searchCondition.siteCodeList" :items="shopItem" item-title="code_name"
                                    item-value="code" :label="$t('tanaoroshiList.label.siteCode')" :multiple="true" />
                            </v-col>
                            <v-col cols="3">
                                <v-text-field density="compact" variant="outlined" hide-details="auto"
                                    v-model="searchCondition.siteName" :label="$t('tanaoroshiList.label.siteName')" />
                            </v-col>
                            <v-col cols="3">
                                <v-select density="compact" variant="outlined" hide-details="auto" :items="[
                                    { 'key': 1, 'label': $t('tanaoroshiList.label.little') },
                                    { 'key': 2, 'label': $t('tanaoroshiList.label.excess') },
                                    { 'key': 3, 'label': $t('tanaoroshiList.label.matched') },
                                ]" :label="$t('tanaoroshiList.label.difference')" item-title="label" item-value="key"
                                    v-model="searchCondition.filterLoss" clearable />
                            </v-col>
                            <v-col cols="3" class="text-right">
                                <v-btn text @click="clear">{{ $t('common.action.clear') }}</v-btn>
                                <v-btn theme="dark" class="ml-4 px-8 bg-grey-darken-3" elevation="2" type="submit"
                                    :loading="isSearching">{{ $t('common.action.search') }}</v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-switch v-model="showZeroInventory" color="blue" inset
                                    :label="$t('tanaoroshiList.label.showZeroInventory')"></v-switch>
                            </v-col>
                        </v-row>
                    </v-form>

                    <v-row>
                        <v-col cols="12">
                            <v-table density="compact" class="text-no-wrap">
                                <thead>
                                    <tr>
                                        <th v-for="header in headers" :key="header" @click.stop="tableSort(header)"
                                            :style="cursorCheck(header)">
                                            {{ $t("tanaoroshiList.label.table." + header) }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="data in filteredDataList" :key="data.siteCode" @click="rowClick(data)"
                                        :style="cursorCheck(null)">
                                        <td v-for="header in headers" :key="header">{{ data[header] }}</td>
                                    </tr>
                                    <tr>
                                        <td :colspan="headers.length"></td>
                                    </tr>
                                </tbody>
                            </v-table>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="3"></v-col>
                        <v-col cols="6">
                            <v-pagination v-model="currentPageNo" :length="maxPageNo" />
                        </v-col>
                        <v-col cols="3">
                            <v-row>
                                <v-spacer></v-spacer>
                                <v-col cols="10" class="d-flex justify-end">
                                    <v-select density="compact" variant="outlined" hide-details="auto"
                                        v-model="displayPerPage" :items="displayPerPageItem" item-title="name"
                                        item-value="value" :label="$t('common.label.displayCountPerPage')"
                                        @update:modelValue="resetCondition()" return-object />
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" class="text-right">
                                    {{ displayContentNo.minNo }} - {{ displayContentNo.maxNo }}{{
                                        $t('common.label.displayedDataRange') }} / {{ sortedTable.length }}{{
                                        $t('common.label.totalCountOf') }}
                                </v-col>
                            </v-row>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="text-right">
                            <v-btn dark class="px-8 bg-indigo-darken-1" elevation="2" @click="downloadCsv"
                                :disabled="sortedTable.length == 0">{{ $t('common.action.outputCsv') }}</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <ZeroData v-if="zeroDataWarningDialogFlg" :handle-ok="closeZeroDataDialog" />
                <MessageDialog v-if="commonMsgDlgVisible" :dialog-data="dataForMsgDialog"
                    :handle-ok="closeMessageDataDialog" />
            </v-main>
        </AppWrapperView>
    </v-app>
</template>

<script lang="js">
import Vue from "vue";
import AppWrapperView from "@/components/views/AppWrapperView";
import api from "@/apis/staff";
import store from "@/store";
import utils from "@/utils";
import router from "@/router/index";
import Paths from "@/router/indexPaths";
import ZeroData from "@/components/dialog/ZeroDataDialog";
import MessageDialog from "@/components/dialog/MessageDialog";

export default {
    components: { AppWrapperView, ZeroData, MessageDialog },
    props: {},
    computed: {
        //どの部分を表示しているのか
        displayContentNo() {
            const minNo = this.sortedTable.length != 0 ? 1 + (this.displayPerPage.value * (this.currentPageNo - 1)) : 0;
            const maxNo = this.displayPerPage.value * (this.currentPageNo);
            if (maxNo > this.sortedTable.length || this.displayPerPage.value == 0) {
                return { minNo: minNo, maxNo: this.sortedTable.length };
            }
            return { minNo: minNo, maxNo: maxNo };
        },

        //最大ページ
        maxPageNo() {
            if (this.displayPerPage.value == 0) return 0;
            return Math.ceil(this.sortedTable.length / this.displayPerPage.value);
        },

        //ソート&日付変換後のデータ
        sortedTable() {
            let tempArray = this.dataList.map(x => x);

            // ソート処理
            if (this.sortState.target != "") {
                //昇順
                if (this.sortState.ascent) tempArray = tempArray.sort((a, b) => {
                    if (a[this.sortState.target] > b[this.sortState.target]) {
                        return 1;
                    }
                    if (a[this.sortState.target] < b[this.sortState.target]) {
                        return -1;
                    }
                    return 0;
                })
                //降順
                else tempArray = tempArray.sort((a, b) => {
                    if (a[this.sortState.target] > b[this.sortState.target]) {
                        return -1;
                    }
                    if (a[this.sortState.target] < b[this.sortState.target]) {
                        return 1;
                    }
                    return 0;
                })
            }

            // 店舗名
            if (this.searchCondition.siteName != "") {
                tempArray = tempArray.filter(x =>
                    x.siteName && x.siteName.startsWith(this.searchCondition.siteName)
                );
            }

            // 差異
            if (this.searchCondition.filterLoss != null) {
                if (this.searchCondition.filterLoss == 1) {
                    // 過少（予定 > 実績）
                    tempArray = tempArray.filter(x => x.plannedStock > x.actualStock);
                } else if (this.searchCondition.filterLoss == 2) {
                    // 過剰（予定 < 実績）
                    tempArray = tempArray.filter(x => x.plannedStock < x.actualStock);
                } else if (this.searchCondition.filterLoss == 3) {
                    // 一致（予定 = 実績）
                    tempArray = tempArray.filter(x => x.plannedStock == x.actualStock);
                }
            }

            // 0件データ非表示
            if (!this.showZeroInventory) {
                tempArray = tempArray.filter(x => x.plannedStock != 0 || x.actualStock != 0);
            }

            return tempArray;
        },

        // ページ区切り後のデータ
        filteredDataList() {
            const tempArray = this.sortedTable;
            return tempArray.slice(this.displayContentNo.minNo - 1, this.displayContentNo.maxNo);
        },

        // ヘッダ
        headers() {
            return this.$getTableDef("TanaoroshiListPage");
        }

    },

    data: () => ({
        currentPageNo: 1,

        //１ページ表示数
        displayPerPage: {},
        displayPerPageItem: [],

        //ソートの状態
        sortState: { target: "", ascent: true },

        // 店舗リスト
        shopItem: [],

        dataList: [],
        searchCondition: {
            siteCodeList: [],       // 店舗コードリスト
            siteName: "",           // 店舗名
            filterLoss: null,       // 差異
        },
        // 0件取得時の警告ダイアログ
        zeroDataWarningDialogFlg: false,
        // 検索中
        isSearching: false,
        // 0件データ表示切替
        showZeroInventory: false,
    }),

    methods: {
        //カーソルの変更
        cursorCheck(value) {
            return "cursor: pointer;"
        },

        // 店舗リストの取得
        // 自店舗検索リスト取得
        // selectSiteFlag：0：他店舗含む / 1：自店舗のみ
        getValidShopSearchList() {
            api.post("/store/search", { selectSiteFlag: 1 })
                .then((response) => {
                    if (response.status == 1) return; //do nothing
                    response.data.results?.shopList.forEach(element => {
                        this.shopItem.push({ name: element.name, code: element.code, code_name: element.code + '_' + element.name })
                    })
                })
                .catch((error) => {
                    //do nothing
                })
        },

        //テーブルの条件リセット
        resetCondition() {
            //１ページ目
            this.currentPageNo = 1;
            //ソートなし
            this.sortState.target = "";
            this.sortState.ascent = true;
        },
        tableSort(headValue) {
            if (headValue == "no") return;
            this.currentPageNo = 1;
            if (this.sortState.target == headValue) {
                this.sortState.ascent = !this.sortState.ascent;
            }
            else {
                this.sortState.target = headValue;
                this.sortState.ascent = true;
            }
        },

        rowClick(item, row) {
            const tanaoroshiData = {
                siteCode: item.siteCode,
                siteName: item.siteName,
                inventoryNo: item.inventoryNo
            };
            store.setTanaoroshi(tanaoroshiData);
            router.push({ name: Paths.TANAOROSHI_SKU_LIST })
        },

        clear() {
            this.searchCondition = {
                siteCodeList: [],
                siteName: "",
                filterLoss: null,
            }
        },

        closeZeroDataDialog() {
            this.zeroDataWarningDialogFlg = false;
        },

        async search() {
            this.isSearching = true;
            api.post("/tanaoroshi/search-by-site", {
                siteCodeList: this.searchCondition.siteCodeList ?? [],
            }
            )
                .then((response) => {
                    this.dataList = response.data.results?.tanaoroshiSearchSiteList ?? [];

                    // 0件ダイアログ処理
                    if (this.dataList.length == 0) this.zeroDataWarningDialogFlg = true;
                    this.isSearching = false;

                })
                .catch((error) => {
                    // 0件 dialog
                    this.dataList = [];
                    this.zeroDataWarningDialogFlg = true;
                    this.isSearching = false;
                })

            this.resetCondition();
        },

        downloadCsv() {
            utils.simpleDownloadCsv(this.headers, this.sortedTable, "tanaoroshiList.label.table.", 'tanaoroshiList.fileNamePrefix.csv', this.$t);
        },
        // 共通メッセージダイアログを閉じる
        closeMessageDataDialog() {
            this.commonMsgDlgVisible = false;
        },
    },
    created() {
        // 棚卸関連のパラメータをクリア
        store.removeTanaShopCode();
        store.removeTanaoroshi();
        this.getValidShopSearchList()
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoutePath = from?.path;
        })
    },
    mounted() {
        this.displayPerPage = utils.getDisplayPerPage(this.$t)
        this.displayPerPageItem = utils.getDisplayPerPageItem(this.$t);
    },
};
</script>

<style></style>